var _path, _rect, _rect2, _rect3, _rect4, _circle, _circle2, _circle3;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var s = Object.getOwnPropertySymbols(e); for (r = 0; r < s.length; r++) o = s[r], t.includes(o) || {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (e.includes(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgIconRouter(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    fill: "currentColor",
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 80 80",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M10,56.75H70a.7502.7502,0,0,0,.75-.75V40a.7502.7502,0,0,0-.75-.75H24.75V18h-1.5V39.25h-4.5V24h-1.5V39.25H10a.7502.7502,0,0,0-.75.75V56A.7502.7502,0,0,0,10,56.75Zm.75-16h58.5v14.5H10.75Z"
  })), _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 23.25,
    y: 48,
    width: 1.5,
    height: 4
  })), _rect2 || (_rect2 = /*#__PURE__*/React.createElement("rect", {
    x: 17.25,
    y: 50,
    width: 1.5,
    height: 2
  })), _rect3 || (_rect3 = /*#__PURE__*/React.createElement("rect", {
    x: 29.25,
    y: 46,
    width: 1.5,
    height: 6
  })), _rect4 || (_rect4 = /*#__PURE__*/React.createElement("rect", {
    x: 35.25,
    y: 44,
    width: 1.5,
    height: 8
  })), _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 50,
    cy: 48,
    r: 1
  })), _circle2 || (_circle2 = /*#__PURE__*/React.createElement("circle", {
    cx: 56,
    cy: 48,
    r: 1
  })), _circle3 || (_circle3 = /*#__PURE__*/React.createElement("circle", {
    cx: 62,
    cy: 48,
    r: 1
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconRouter);
export default __webpack_public_path__ + "static/media/icon_router.b79c46bf7c2686ff22040ef9836bdb0c.svg";
export { ForwardRef as ReactComponent };